import { Button, HStack, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { useStores } from "../../../../shared/stores/RootStore";

export const ForecastHeader: React.FC = () => {
  const { forecastStore } = useStores();

  return (
    <HStack
      p={2}
      fontSize="sm"
      bgColor="primary.100"
      justifyContent="center"
      gap={4}
    >
      <Text>{t("map:forecast.header.text")}</Text>
      <Button
        variant="outline"
        size="xs"
        colorPalette="primary"
        onClick={() => forecastStore.restoreOriginal()}
      >
        {t("map:forecast.header.resetBtn")}
      </Button>
    </HStack>
  );
};
